export default __webpack_public_path__ + "static/media/item-delete.863e923b.svg";